import { BrandingImage, BrandingStyle, ModalOpen } from "@bcm-dev/bcms-vite";
import { LayoutContainer, LeftColumnContainer, RightColumnContainer } from "components/shared";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
import "./mobile.css";

/**
 * @function PageHeaderView 
 * @param {React.Component} children - Allows us to inject other components/content. 
 * @returns {React.Component}
 * @example
 * <PageContentView>
 *  <PageHeaderView/>
 * </PageContentView>
 */

export default function PageHeaderView(props) {
  return (
      <div className="page-header-view show-on-desktop">
        <div className="page-header-content flex-container flex-vertical align-center">
          {props.children}
        </div>
      </div>
  );
}

/**
 * @function MobilePageHeaderView
 * @returns {React.Component}
 * @example
 * <PageContentView>
 *  <MobilePageHeaderView />
 * </PageContentView>
 */
export function MobilePageHeaderView(props) {
  return (
    <div className="mobile-page-header-view show-on-mobile">
      <LayoutContainer>
        <LeftColumnContainer dataPoint="Header_Logo">
          <a href="#/accountSummary">
            <BrandingImage id="header_logo_abi22" className="page-header-logo" />
          </a>
        </LeftColumnContainer>
        <RightColumnContainer>
          <ModalOpen id="MobileNavView">
            <BrandingStyle
              style={{ "color": "mobile_hamburger_menu_abi22", "fill": "mobile_hamburger_menu_abi22" }}
              className="menu-button-container flex-container flex-horizontal align-center justify-right text-right clickable">
              <div className="menu-icon-container set-width">
                <SVGAsset id="HamburgerMenuIcon" data-point="Mobile_Menu_Icon" />
              </div>
              <div className="set-width">
                <span data-point="Mobile_Menu_Label">Menu</span>
              </div>
            </BrandingStyle>
         
          </ModalOpen>
        </RightColumnContainer>
      </LayoutContainer>
    </div>
  );
}